import clsx from 'clsx';
import { Button } from '../buttons/Button';
import { Link } from 'react-router';
import { IconLock, IconPlaceholder } from '../Icon';
import {
    UilBrain,
    UilFocusAdd,
    UilHeart,
    UilKid,
    UilSmileBeam,
    UilTornado,
} from '@iconscout/react-unicons';
import { Color } from '../../lib/types.ts';

interface CategoryCardProps {
    color: Color;
    heading: string;
    subheading: string;
    isLocked?: boolean;
    icon?: string;
    href: string;
}

export default function CategoryCard({
    color,
    heading,
    subheading,
    isLocked = false,
    icon,
    href,
}: CategoryCardProps) {
    const colorVariants = {
        blue: 'from-blue-600 to-blue-500',
        green: 'from-green-600 to-green-500',
        orange: 'from-orange-600 to-orange-500',
        red: 'from-red-600 to-red-500',
        turquoise: 'from-turquoise-600 to-turquoise-500',
        purple: 'from-purple-600 to-purple-500',
        rose: 'from-rose-600 to-rose-500',
    };

    const icons = {
        brain: UilBrain,
        concentration: UilFocusAdd,
        heart: UilHeart,
        smileBeam: UilSmileBeam,
        tornado: UilTornado,
        kid: UilKid,
        placeholder: IconPlaceholder,
    };

    const iconsKey = (icon as keyof typeof icons) ?? 'placeholder';

    const Icon = isLocked
        ? IconLock
        : icons[iconsKey in icons ? iconsKey : 'placeholder'];

    return (
        <div
            className={clsx(
                'flex min-h-60 flex-col items-start justify-start rounded-3xl p-8',
                'bg-gradient-to-r', // TODO: should be 100deg
                colorVariants[color]
            )}
        >
            <div className="mb-4 flex items-center">
                <div className="mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-white/10">
                    <Icon className="text-white" size={24} />
                </div>
                <h3 className="tracking-wide text-white">{heading}</h3>
            </div>
            <p className="text-white">{subheading}</p>
            {!isLocked && (
                <Link to={href} className="mb-0 mt-auto">
                    <Button color="opaque" className="mt-6">
                        Zobrazit cvičení
                    </Button>
                </Link>
            )}
        </div>
    );
}
